import * as React from "react"

import { X } from "lucide-react"

import { cn } from "@lib/utils"

interface InputProps extends React.ComponentProps<"input"> {
    onClear?: () => void
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, onClear, ...props }, ref) => {
    const showClearButton = onClear && props.value

    return (
        <div className="relative w-full">
            <input type={type} className={cn("flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", showClearButton && "pr-8", className)} ref={ref} {...props} />
            {showClearButton && (
                <button type="button" onClick={onClear} className="absolute right-2 top-1/2 -translate-y-1/2 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-1 focus:ring-ring hover:cursor-pointer">
                    <X className="h-4 w-4" />
                    <span className="sr-only">Clear</span>
                </button>
            )}
        </div>
    )
})
Input.displayName = "Input"

export { Input }
